var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkoutsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.23,
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#D0D8DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0083 24.4365L24.435 18.0097L25.9905 19.5652L19.5638 25.992L18.0083 24.4365Z",
    fill: "#7E898F",
    stroke: "#7E898F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8376 12.3937C25.5877 12.6437 25.4473 12.9828 25.4473 13.3363C25.4473 13.6898 25.5877 14.0288 25.8376 14.2788L29.7224 18.1636C29.8462 18.2874 29.9932 18.3857 30.1549 18.4527C30.3166 18.5198 30.49 18.5543 30.6651 18.5543C30.8402 18.5544 31.0136 18.5199 31.1753 18.453C31.3371 18.386 31.4841 18.2878 31.6079 18.1641C31.7318 18.0403 31.83 17.8933 31.8971 17.7316C31.9641 17.5698 31.9986 17.3965 31.9987 17.2214C31.9987 17.0463 31.9643 16.8729 31.8973 16.7112C31.8303 16.5494 31.7322 16.4024 31.6084 16.2785L27.7227 12.3937C27.4727 12.1438 27.1336 12.0034 26.7801 12.0034C26.4266 12.0034 26.0876 12.1438 25.8376 12.3937Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0665 12.3916C21.9427 12.5154 21.8444 12.6624 21.7773 12.8242C21.7103 12.986 21.6758 13.1594 21.6758 13.3346C21.6758 13.5097 21.7103 13.6832 21.7773 13.845C21.8444 14.0068 21.9427 14.1538 22.0665 14.2776L29.7232 21.9342C29.8472 22.058 29.9944 22.1561 30.1563 22.223C30.3183 22.2899 30.4918 22.3243 30.667 22.3241C30.8422 22.3239 31.0157 22.2893 31.1775 22.2221C31.3393 22.1549 31.4863 22.0564 31.61 21.9324C31.7338 21.8084 31.8319 21.6613 31.8988 21.4993C31.9657 21.3374 32.0001 21.1639 31.9999 20.9887C31.9998 20.8134 31.9651 20.64 31.8979 20.4782C31.8307 20.3164 31.7323 20.1694 31.6083 20.0456L23.9552 12.3916C23.8313 12.2673 23.6841 12.1687 23.5221 12.1014C23.36 12.0341 23.1863 11.9995 23.0109 11.9995C22.8354 11.9995 22.6617 12.0341 22.4996 12.1014C22.3376 12.1687 22.1904 12.2673 22.0665 12.3916Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3913 25.8385C12.5151 25.7146 12.6621 25.6164 12.8239 25.5493C12.9857 25.4823 13.1591 25.4478 13.3343 25.4478C13.5094 25.4478 13.6828 25.4823 13.8446 25.5493C14.0064 25.6164 14.1534 25.7146 14.2772 25.8385L18.162 29.7233C18.4048 29.9747 18.5392 30.3115 18.5362 30.661C18.5331 31.0106 18.3929 31.3449 18.1458 31.5921C17.8986 31.8393 17.5642 31.9795 17.2147 31.9825C16.8651 31.9856 16.5284 31.8512 16.277 31.6083L12.3913 27.7236C12.1414 27.4736 12.001 27.1346 12.001 26.7811C12.001 26.4276 12.1414 26.0885 12.3913 25.8385Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3916 22.0656C12.6416 21.8157 12.9806 21.6753 13.3341 21.6753C13.6876 21.6753 14.0266 21.8157 14.2766 22.0656L21.9333 29.7223C22.1834 29.9727 22.3237 30.3123 22.3235 30.6662C22.3232 31.0201 22.1824 31.3595 21.9319 31.6095C21.6815 31.8596 21.342 32 20.988 31.9997C20.6341 31.9995 20.2948 31.8587 20.0447 31.6082L12.3916 23.9551C12.2672 23.8312 12.1684 23.684 12.1011 23.5219C12.0337 23.3598 11.999 23.1859 11.999 23.0104C11.999 22.8348 12.0337 22.661 12.1011 22.4988C12.1684 22.3367 12.2672 22.1895 12.3916 22.0656Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkoutsIcon);
export default __webpack_public_path__ + "static/media/WorkoutsIcon.3189c094717242644998dec00c1d328b.svg";
export { ForwardRef as ReactComponent };